<template>
	<div class="flex justify-center py-4">
		<div>
			<div class="flex items-center">
				<div class="flex">
					<div class="pr-2">
						<button
							@click="getPage('last')"
							:disabled="store.pagination.page === 1"
							class="focus:outline-none"
							:class="isButtonDisabled(store.pagination.page === 1)"
							data-vs-button="get-page"
						>
							<zt-icon name="arrow-left-outline" />
						</button>
					</div>
					<div class="pl-2">
						<button
							@click="getPage('next')"
							:disabled="store.pagination.page === store.pageCount"
							class="focus:outline-none"
							:class="isButtonDisabled(store.pagination.page === store.pageCount)"
			  				data-vs-button="get-next-page"
						>
							<zt-icon name="arrow-right-outline" />
						</button>
					</div>
				</div>
				<div class="ml-2 flex items-baseline">
					<p class="text-zt-dark-300">
            {{ $t('message.searchComponent.goTo') }}
          </p>
					<div class="h-full ml-2 pl-2 w-8 border-zt-dark-300 border-2 rounded">
						<input
							:value="store.pagination.page"
							@keypress.enter="setGotoPage($event)"
							type="text"
							class="py-1 h-full focus:outline-none w-full"
							data-vs-input="set-page"
						/>
					</div>
				</div>
				<div class="ml-2">
					<div class="rounded relative border-2 border-zt-dark-300">
						<select
							v-model="newRowQuantity"
							class="block appearance-none w-full py-1 text-gray-700 pl-2 pr-8 rounded leading-tight focus:outline-none bg-white"
							data-vs-select="new-row"
						>
							<option
								:value="option"
								v-for="(option, index) in paginationOpts"
								:key="index"
							>
                {{ `${option}/${$t('message.searchComponent.page')}` }}
              </option>
						</select>
						<div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-zt-primary-200">
							<svg
								class="fill-current h-4 w-4"
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 20 20"
							>
								<path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
							</svg>
						</div>
					</div>
				</div>
				<div class="ml-2">
					<p class="text-zt-dark-300">
						{{ $t('message.searchComponent.total') }}: <span>{{ store.total }}</span>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	inject: ['store', 'setPagination'],
	data () {
		return {
			paginationOpts: [20, 50, 100, 500],
		}
	},
	computed: {
		isButtonDisabled () {
			return status => (status ? 'text-zt-dark-300' : 'text-zt-primary-200')
		},
		newRowQuantity: {
			set (value) {
				const {
					pagination: { page }
				} = this.store
				this.setPagination({ page, rows: value })
			},
			get () {
				return this.store.pagination.rows
			}
		},
	},
	methods: {
		getPage (pageRequest) {
			const {
				pagination: { page, rows }
			} = this.store
			
			this.$emit('page-change', true)

			if (pageRequest === 'last' && page > 1) {
				return this.setPagination({ page: page - 1, rows })
			}

			if (pageRequest === 'next' && page <= this.store.pageCount) {
				return this.setPagination({ page: page + 1, rows })
			}
		},
		setGotoPage (event) {
			const value = event.target.value
			const { pagination: { rows } } = this.store

			this.$emit('page-change', true)
			
			if (value && value > 0 && value <= this.store.pageCount) {
				return this.setPagination({ rows, page: value })
			}

			this.setPagination({ rows, page: 1 })
		}
	}
}
</script>
